import React, { Component } from "react"
import axios from "axios"
import theme from "../styles/theme"
import styled from "@emotion/styled"

const Outer = styled.div`
  padding: 0 32px;
`
const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: auto;
  grid-gap: 32px;
  align-items: center;
  max-width: ${theme.maxwidth.default};
  margin-left: auto;
  margin-right: auto;
  @media (max-width: ${theme.breakpoints.desktop}) {
    grid-template-columns: 1fr;
  }
`
const Container2 = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`
const Content = styled.div`
  padding: 64px 0 32px 0;
  width: 800px;
  margin: 0 auto;
  color: ${theme.color.ink};

  @media (max-width: 864px) {
    width: 100%;
  }

  a {
    color: ${theme.color.ink};
  }
`

const Card = styled.div`
  border: solid 2px ${theme.color.shade.stone};
  border-radius: 8px;
  padding: 32px 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
`

const Title = styled.h2`
  font-size: 1.5rem;
  line-height: 1.33em;
  letter-spacing: -0.24px;
  font-weight: 600;
  margin-bottom: 16px;
`

const List = styled.ul`
  list-style-type: disc;
  margin: 0;
  padding: 0;
  margin-left: 12px;
  margin-bottom: 16px;

  li {
    font-size: 8px;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  span {
    font-size: 0.875rem;
    line-height: 1.71em;
    letter-spacing: -0.14px;
  }
`

const Price = styled.div`
  font-size: 1.5rem;
  line-height: 1.33em;
  letter-spacing: -0.24px;
  font-weight: 600;
  margin-bottom: 0;
  color: ${theme.color.ink};

  span {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.71em;
    letter-spacing: -0.14px;
    margin-right: 24px;
  }
`

export default class ProfessionalServices extends Component {
  constructor(props) {
    super(props)
    this.state = {
      services: []
    }
  }

  componentDidMount() {
    this.setState({      
      services: [
      {
        title: "Best Practices Onboarding",
      priceText: <div>{this.props.currency}2,000</div>,
        features: [
          "5, 45-min sessions with a Stack co-founder in the first 6 -12 weeks after sign up",
          "Tips on efficiently setting up the product and getting the most out of it",
        ],
      },
      {
      title: "Quarterly Accountability & Planning",
      priceText: <div>{this.props.currency}3,000</div>,
        features: [
          "4, personal 90-minute sessions with a Stack co-founder over the initial 12 months",
          "Look back, iterate product/process, 90-day plan",
        ],
      },
      {
        title: "In Person Workshop",
        priceText: (
          <div>
            {this.props.currency}4,000 <span>1/2 day</span> {this.props.currency}7,000 <span>full day</span>
          </div>
        ),
        features: [
          "Group or individual working session with a Stack co-founder",
          "Customized topics on the Stack product",
          "Coaching & working with the team on sales execution",
        ],
      },
      {
        title: "Virtual Workshop",
      priceText: <div>{this.props.currency}1,500</div>,
        features: [
          "2-3 hour session with a Stack co-founder",
          "Customized topics on the Stack product",
          "Coaching & working with the team on sales execution",
        ],
      },
    ]})
  }

  //Not good but good enough for now
  componentDidUpdate(prevProps) {

    if(prevProps.currency !== this.props.currency) {
      this.setState({      
        services: [
        {
          title: "Best Practices Onboarding",
        priceText: <div>{this.props.currency}2,000</div>,
          features: [
            "5, 45-min sessions with a Stack co-founder in the first 6 -12 weeks after sign up",
            "Tips on efficiently setting up the product and getting the most out of it",
          ],
        },
        {
        title: "Quarterly Accountability & Planning",
        priceText: <div>{this.props.currency}3,000</div>,
          features: [
            "4, personal 90-minute sessions with a Stack co-founder over the initial 12 months",
            "Look back, iterate product/process, 90-day plan",
          ],
        },
        {
          title: "In Person Workshop",
          priceText: (
            <div>
              {this.props.currency}4,000 <span>1/2 day</span> {this.props.currency}7,000 <span>full day</span>
            </div>
          ),
          features: [
            "Group or individual working session with a Stack co-founder",
            "Customized topics on the Stack product",
            "Coaching & working with the team on sales execution",
          ],
        },
        {
          title: "Virtual Workshop",
        priceText: <div>{this.props.currency}1,500</div>,
          features: [
            "2-3 hour session with a Stack co-founder",
            "Customized topics on the Stack product",
            "Coaching & working with the team on sales execution",
          ],
        },
      ]})
    }
  }

  render() {
    console.log()
    return (
      <Outer>
        <Container2 style={{ textAlign: "center" }}>
          <Content>{this.props.content}</Content>
        </Container2>
        <Container>
          {this.state.services.map((service, i) => {
            return (
              <Card key={`professional_${i}`}>
                <Title>{service.title}</Title>
                <List>
                  {service.features.map((feature, j) => {
                    return (
                      <li key={`professional_${i}_features_${j}`}>
                        <span>{feature}</span>
                      </li>
                    )
                  })}
                </List>

                <Price>{service.priceText}</Price>
              </Card>
            )
          })}
        </Container>
      </Outer>
    )
  }
}
